import 'flowbite';
import { initFlowbite } from 'flowbite';

import "./ui/theme-toggle.ts";

import.meta.hot.accept()

globalThis.addEventListener('DOMContentLoaded', () => {
    console.log('DOM fully loaded and parsed');
    initFlowbite();
});